import { render } from "./ProductsVersionView.vue?vue&type=template&id=1953d76e&scoped=true"
import script from "./ProductsVersionView.vue?vue&type=script&lang=js"
export * from "./ProductsVersionView.vue?vue&type=script&lang=js"

import "./ProductsVersionView.vue?vue&type=style&index=0&id=1953d76e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1953d76e"]])

export default __exports__